import React, { useEffect, useState } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField, FormControl, InputLabel, Select, MenuItem, Slide, Grid, FormControlLabel, Switch } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useEditUserMutation } from '../../services/api';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const EditUserDialogBox = ({ open, onClose, user, roleOptions = ['Admin', 'User'], refetch }) => {
    const theme = useTheme();

    const [editUser] = useEditUserMutation();
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        phoneNumber: '',
        country: '',
        role: '',
        active: false,
    });

    // Fetch user data
    useEffect(() => {
        if (user) {
            setFormData({
                name: user.name || '',
                email: user.email || '',
                phoneNumber: user.phoneNumber || '',
                country: user.country || '',
                role: user.role?.name || '',
                active: user.active || false,
            });
        }
    }, [user]);

    // Handle input change
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    // Handle switch change
    const handleSwitchChange = (e) => {
        setFormData((prev) => ({ ...prev, active: e.target.checked }));
    };

    // Handle save
    const handleSave = async () => {
        try {
            await editUser({ userId: user._id, data: formData }).unwrap();
            refetch();
            onClose();
        } catch (error) {
            console.error('Failed to update user:', error);
        }
    };

    return (
        <Dialog
            open={open}
            TransitionComponent={Transition}
            onClose={onClose}
            aria-describedby="edit-user-dialog-description"
            PaperProps={{
                sx: {
                    backgroundColor: theme.palette.background.paper,
                    width: '600px',
                    padding: theme.spacing(2),
                },
            }}
        >
            <DialogTitle sx={{ color: theme.palette.text.white }} variant="h2" fontWeight="bold">
                Edit User
            </DialogTitle>

            <DialogContent>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <TextField fullWidth margin="dense" label="Name" name="name" value={formData.name} onChange={handleInputChange} />
                    </Grid>
                    <Grid item xs={12}>
                        <TextField fullWidth margin="dense" label="Email" name="email" value={formData.email} onChange={handleInputChange} />
                    </Grid>
                    <Grid item xs={12}>
                        <TextField fullWidth margin="dense" label="Phone Number" name="phoneNumber" value={formData.phoneNumber} onChange={handleInputChange} />
                    </Grid>
                    <Grid item xs={12}>
                        <TextField fullWidth margin="dense" label="Country" name="country" value={formData.country} onChange={handleInputChange} />
                    </Grid>
                    <Grid item xs={12}>
                        <FormControl fullWidth margin="dense">
                            <InputLabel id="role-label">Role</InputLabel>
                            <Select labelId="role-label" name="role" value={formData.role} label="Role" onChange={handleInputChange}>
                                {roleOptions.map((role) => (
                                    <MenuItem key={role} value={role}>
                                        {role}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12}>
                        <FormControlLabel control={<Switch checked={formData.active} onChange={handleSwitchChange} color="primary" />} label="Active" />
                    </Grid>
                </Grid>
            </DialogContent>

            <DialogActions sx={{ padding: theme.spacing(2) }}>
                <Button
                    onClick={onClose}
                    variant="contained"
                    sx={{
                        color: theme.palette.text.black,
                        backgroundColor: theme.palette.text.white,
                        fontWeight: 'bold',
                        '&:hover': {
                            backgroundColor: theme.palette.text.white,
                        },
                    }}
                >
                    Cancel
                </Button>
                <Button
                    onClick={handleSave}
                    variant="contained"
                    sx={{
                        color: theme.palette.text.black,
                        backgroundColor: theme.palette.text.white,
                        fontWeight: 'bold',
                        '&:hover': {
                            backgroundColor: theme.palette.text.white,
                        },
                    }}
                >
                    Save
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default EditUserDialogBox;
